import { connectedStore } from '../../store';
import selectors from '../selectors';

const getExtensionSettings = (extensionSlug) => {
  const store = connectedStore.get();
  const state = store.getState();

  return selectors.getExtensionSettings(state, extensionSlug);
};

export default getExtensionSettings;
